<template>
    <div>
        <loading
            :active.sync="loadingApp"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light">
            <div class="left">
                <a
                    @click="$router.go(-1)"
                    class="headerButton"
                    style="cursor:pointer;"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Detail Transaksi</div>
        </div>
        <!-- * App Header -->
        <div id="appCapsule" class="pb-2" v-if="loadingApp == false">
            <div
                class="section detail-transaction-section pt-4"
                style="--height:150px;"
            >
                <div class="detail-card">
                    <div class="listed-detail mt-1">
                        <div class="text-center">
                            <img
                                v-lazyload
                                :src="require('@/assets/Loader-2.png')"
                                :data-src="require('@/assets/bank.png')"
                                alt="logo_bank"
                                class="imaged"
                                style="width:20%;"
                            />
                        </div>
                        <h3 class="text-center mt-2 mb-1">
                            {{ transaction.product_name }}
                        </h3>
                        <h4 class="text-center" style="font-weight: bold;">
                            {{ transaction.no_rekening }}
                        </h4>
                    </div>
                    <div class="listed-detail mt-1">
                        <dd class="mb-0">
                            ID Transkasi <b>#{{ transaction.id }}</b>
                        </dd>
                        <dd class="mb-0">
                            Status Transkasi<br />
                            <div
                                class="chip chip-warning"
                                v-if="
                                    transaction.status == 'PENDING' ||
                                        transaction.status == 'ONPROCESS'
                                "
                            >
                                <span class="chip-label">Pending</span>
                            </div>
                            <div
                                class="chip chip-success"
                                v-if="transaction.status == 'SUCCESS'"
                            >
                                <span class="chip-label">Berhasil</span>
                            </div>
                            <div
                                class="chip chip-danger"
                                v-if="transaction.status == 'FAILED'"
                            >
                                <span class="chip-label">Gagal</span>
                            </div>
                            <div
                                class="chip chip-primary"
                                v-if="transaction.status == 'HOLDON'"
                            >
                                <span class="chip-label">Holdon</span>
                            </div>
                        </dd>
                        <dd class="mb-0">
                            <small>Tanggal {{ transaction.created_at }}</small>
                        </dd>
                    </div>
                    <div class="listed-detail mt-1">
                        <blockquote class="blockquote p-1 mt-2 mb-1">
                            <h5 class="mb-0 ml-1">
                                Detail Transaksi
                            </h5>
                        </blockquote>
                        <table>
                            <tr>
                                <td width="150px">Bank</td>
                                <td width="20px">:</td>
                                <td>{{ transaction.product_name }}</td>
                            </tr>
                            <tr>
                                <td width="150px">No. Rekening</td>
                                <td width="20px">:</td>
                                <td>{{ transaction.no_rekening }}</td>
                            </tr>
                            <tr>
                                <td width="150px">Nama Rekening</td>
                                <td width="20px">:</td>
                                <td>{{ transaction.nama_rekening }}</td>
                            </tr>
                            <tr>
                                <td width="150px">Nominal</td>
                                <td width="20px">:</td>
                                <td>
                                    <b>Rp {{ transaction.nominal | rupiah }}</b>
                                </td>
                            </tr>
                            <tr>
                                <td width="150px">No. Referensi</td>
                                <td width="20px">:</td>
                                <td style="word-wrap: break-word">
                                    {{ transaction.serial_number }}
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="listed-detail mt-1">
                        <blockquote class="blockquote p-1 mt-2 mb-1">
                            <h5 class="mb-0 ml-1">
                                Detail Pembayaran
                            </h5>
                        </blockquote>
                        <table>
                            <tr>
                                <td width="150px">Metode</td>
                                <td width="20px">:</td>
                                <td>Saldo Akun</td>
                            </tr>
                            <tr>
                                <td width="150px">Biaya Layanan</td>
                                <td width="20px">:</td>
                                <td>Rp {{ transaction.fee_admin | rupiah }}</td>
                            </tr>
                            <tr>
                                <td width="150px">Total Bayar</td>
                                <td width="20px">:</td>
                                <td>
                                    <b>Rp {{ transaction.total | rupiah }}</b>
                                </td>
                            </tr>
                            <tr>
                                <td width="150px">Cashback</td>
                                <td width="20px">:</td>
                                <td>Rp {{ transaction.cashback | rupiah }}</td>
                            </tr>
                            <tr>
                                <td width="150px">Points</td>
                                <td width="20px">:</td>
                                <td class="text-warning">
                                    +{{
                                        transaction.status == 'SUCCESS'
                                            ? transaction.points
                                            : 0 | rupiah
                                    }}
                                    points
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="listed-detail mt-1" style="border-bottom:0px;">
                        <table>
                            <tr>
                                <td width="150px">Biaya ke Pelanggan</td>
                                <td width="20px">:</td>
                                <td style="display: inline-flex;">
                                    <div v-if="transaction.status == 'FAILED'">
                                        Rp
                                        {{ transaction.fee_customer }}
                                    </div>
                                    <div v-else>
                                        <a
                                            href="Javascript:;"
                                            class="mb-0 text-primary"
                                            style="font-weight: bold;text-decoration: underline;"
                                            v-if="
                                                transaction.fee_customer != ''
                                            "
                                            @click="
                                                dialogUpdateFeeCustomer('show')
                                            "
                                            >Rp
                                            {{ transaction.fee_customer }}
                                            <i
                                                class="icon ion-md-create"
                                                style="margin-left: 2px;"
                                            ></i>
                                        </a>
                                        <label class="mb-0" v-else
                                            ><ion-icon
                                                name="ellipsis-horizontal"
                                            ></ion-icon
                                        ></label>
                                    </div>
                                </td>
                            </tr>
                        </table>

                        <div
                            class="alert alert-grey-custom mt-1 mb-1 pt-2 pb-2"
                            role="alert"
                            style="background: rgba(237, 237, 241, 0.5);"
                        >
                            <div
                                class="alert-custom-container pb-1"
                                style="border-bottom: 1px dashed #c5c9ce;"
                            >
                                <div class="alert-custom-description">
                                    <b>Total Bayar Pelanggan</b>
                                </div>
                                <span
                                    style="font-size:16px;color:#17273e;font-weight: 700;"
                                >
                                    Rp
                                    {{
                                        (transaction.nominal +
                                            parseInt(
                                                transaction.fee_customer.replace(
                                                    /[^,\d]/g,
                                                    ''
                                                )
                                            ))
                                            | rupiah
                                    }}
                                </span>
                            </div>
                            <div class="mt-1">
                                <small
                                    ><i
                                        >*) Potensi Keuntungan dari Penjualan ke
                                        Pelanggan sebesar
                                        <b class="text-success"
                                            >Rp
                                            {{ potensiKeuntungan | rupiah }}</b
                                        ></i
                                    ></small
                                >
                            </div>
                        </div>
                    </div>
                    <div
                        class="listed-detail mt-1"
                        style="border-bottom:0px;"
                        v-if="transaction.status == 'SUCCESS'"
                    >
                        <button
                            class="btn btn-primary btn-block"
                            @click="print()"
                        >
                            <ion-icon name="print"></ion-icon> Print Struk
                        </button>
                        <a
                            :href="
                                'https://api.whatsapp.com/send?text=Kirim Uang ke ' +
                                    transaction.product_name +
                                    ' dengan nomor rekening ' +
                                    transaction.no_rekening +
                                    ' a.n ' +
                                    transaction.nama_rekening +
                                    ' telah berhasil. No Referensi : ' +
                                    transaction.serial_number +
                                    ' pada ' +
                                    transaction.created_at +
                                    ' sebesar Rp ' +
                                    $options.filters.inputRupiah(
                                        transaction.nominal
                                    ) +
                                    '. Terima Kasih'
                            "
                            target="_blank"
                            class="btn btn-success btn-block"
                        >
                            <ion-icon name="logo-whatsapp"></ion-icon> Kirim
                            Laporan Transkasi
                        </a>
                        <a
                            :href="
                                'https://play.google.com/store/apps/details?id=' +
                                    VUE_ENV.VUE_APP_PACKAGENAME_APK
                            "
                            target="_blank"
                            class="btn btn-dark btn-block"
                        >
                            <ion-icon name="logo-google-playstore"></ion-icon>
                            Beri Rating
                        </a>
                        <!-- <button class="btn btn-primary btn-block" @click="coming()"><ion-icon name="cloud-download"></ion-icon> Download Struk</button> -->
                    </div>
                </div>
            </div>
        </div>

        <!-- Dialog update fee customer -->
        <Dialog
            ref="dialog_update_fee_customer"
            :loading="loadingUpdateFeeCustomer"
            :title="'Ubah Biaya ke Pelanggan'"
            @confirm="updateFeeCustomer()"
        >
            <div class="form-group input-nominal p-2">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Rp</span>
                    </div>
                    <input
                        type="tel"
                        class="form-control form-control-lg"
                        v-model="transaction.fee_customer"
                        oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                        @input="inputFeeCustomer()"
                    />
                </div>
            </div>

            <div
                class="form-group basic mt-1 pb-0"
                style="white-space: nowrap; overflow: auto;"
            >
                <button
                    v-for="item in nominal_fee_customer"
                    :key="item"
                    class="btn btn-outline-primary btn-sm mr-1"
                    style="border-radius:50px;border:1px solid;"
                    @click="inputFeeCustomer(item)"
                >
                    <ion-icon name="add-circle"></ion-icon> Rp
                    {{ item | rupiah }}
                </button>
            </div>
        </Dialog>
    </div>
</template>
<script>
    import $axios from '../../../../api.js';
    import { mapActions, mapState } from 'vuex';
    export default {
        data() {
            return {
                transaction: {},
                loadingApp: true,
                loadingButton: false,
                loadingUpdateFeeCustomer: false,
                nominal_fee_customer: [5000, 8000, 10000],
            };
        },
        created() {
            this.getDetail(this.$route.params.id);
        },
        computed: {
            ...mapState(['errors', 'toast', 'VUE_ENV']),
            potensiKeuntungan() {
                let nominal = parseInt(this.transaction.nominal);
                let fee_customer = parseInt(
                    this.transaction.fee_customer.replace(/[^,\d]/g, '')
                );
                let fee_admin = parseInt(this.transaction.fee_admin);
                let price = nominal + fee_admin;
                let price_customer = nominal + fee_customer;
                return price_customer - price;
            },
        },
        methods: {
            ...mapActions(['coming']),
            dialogUpdateFeeCustomer(value) {
                let element = this.$refs.dialog_update_fee_customer.$el;
                window.$(element).modal(value);
            },
            updateFeeCustomer() {
                this.loadingUpdateFeeCustomer = true;
                $axios
                    .post(
                        '/sendmoney/history/' +
                            this.$route.params.id +
                            '/update-fee-customer',
                        {
                            fee_customer: this.transaction.fee_customer,
                        }
                    )
                    .then(() => {
                        this.loadingUpdateFeeCustomer = false;
                        this.dialogUpdateFeeCustomer('hide');
                        this.getDetail(this.$route.params.id);
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message: 'Berhasil',
                            tipe: 'default',
                            icon: 'success',
                        });
                    })
                    .catch(error => {
                        this.dialogUpdateFeeCustomer('hide');
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message: error.response.data.message,
                            tipe: 'default',
                            icon: 'danger',
                        });
                        this.loadingUpdateFeeCustomer = false;
                    });
            },
            getDetail(id) {
                $axios
                    .get('/sendmoney/history/' + id)
                    .then(response => {
                        this.transaction = response.data.data;
                        this.transaction.fee_customer = this.$options.filters.rupiah(
                            response.data.data.fee_customer
                        );
                        this.loadingApp = false;
                    })
                    .catch(() => {
                        this.loadingApp = false;
                    });
            },
            print() {
                if (typeof window.AndroidNative !== 'undefined') {
                    window.AndroidNative.print();
                } else {
                    this.$store.commit('SET_TOAST', {
                        show: true,
                        message:
                            'Fitur ini hanya bisa digunakan diperangkat Android, silahkan download aplikasi di Playstore',
                        tipe: 'default',
                        icon: 'warning',
                    });
                }
            },
            inputFeeCustomer(nominal) {
                this.$store.commit('RESET_TOAST');
                if (this.transaction.fee_customer == '') {
                    this.transaction.fee_customer = '0';
                }
                if (nominal == undefined) {
                    const nominal_request = parseInt(
                        this.transaction.fee_customer
                    );
                    this.transaction.fee_customer = this.$options.filters.inputRupiah(
                        nominal_request.toString()
                    );
                } else {
                    const nominal_request =
                        parseInt(
                            this.transaction.fee_customer.replace(/[^,\d]/g, '')
                        ) + nominal;
                    this.transaction.fee_customer = this.$options.filters.inputRupiah(
                        nominal_request.toString()
                    );
                }
            },
        },
        destroyed() {
            this.$store.commit('CLEAR_ERRORS');
            this.$store.commit('RESET_TOAST');
        },
        filters: {
            inputRupiah: function(value) {
                value = value.toString();
                var number_string = value.replace(/[^,\d]/g, '').toString(),
                    split = number_string.split(','),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);

                if (ribuan) {
                    var separator = sisa ? '.' : '';
                    rupiah += separator + ribuan.join('.');
                }

                rupiah =
                    split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
                return rupiah;
            },
        },
    };
</script>
